import { MB_DIALOG_DATA, MbDialogData, MbDialogRef } from '@am/moebius';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { SearchService } from '@services/search.service';

@Component({
  selector: 'am-searchbox-modal',
  styleUrls: ['./searchbox-modal.component.scss'],
  templateUrl: './searchbox-modal.component.html',
})
export class SearchBoxModalComponent {
  constructor(
    @Inject(MB_DIALOG_DATA) public dialogData: MbDialogData,
    public dialogRef: MbDialogRef<SearchBoxModalComponent>,
    private searchService: SearchService,
    private router: Router,
  ) {}

  public closeDialog() {
    this.dialogRef.close();
  }

  public handleSearch(data) {
    if (this.searchService.searchValidator(data)) {
      this.searchService
        .prepareNavigationData(data)
        .subscribe((uri) => {
          if (uri) {
            this.router.navigate([uri.path], {
              queryParams: uri.params,
            });
          }
        })
        .unsubscribe();
      this.closeDialog();
    }
  }
}
